import AdvancedPotionMakingV2 from "../../edition-II-prince's-copy";
import { Redirect } from "react-router-dom";
import { ReplicaVersionType } from "types";
import { createDate } from "utils";
import { routes } from "config";
import thumbnail from "./thumbnail.png";

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 18, month: 8, year: 2022 }),
  datePublished: createDate({ day: 9, month: 2, year: 2023 }),
  version: "2",
  isSeries: false,
  thumbnail,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <Redirect
      to={
        "/" +
        routes.replicas.slug +
        "/" +
        AdvancedPotionMakingV2.id +
        "/v2" +
        "#clean-vs-prince"
      }
    />
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
